import { createContext, useContext } from "react";

/**
 * Whether the sidebar is a rail of icons from `md` up (WP-056). A page whose own list moved into
 * the sidebar (Chat's conversations) shows it again in the page while the sidebar is a rail.
 */
export const SidebarCollapsed = createContext(false);

export function useSidebarCollapsed(): boolean {
  return useContext(SidebarCollapsed);
}
